import {
  RETURN_TRANSACTION_BILL_REF_NO_FILTER,
  RETURN_TRANSACTION_DOC_NUMBER_FILTER,
  RETURN_TRANSACTION_DOC_REF_NUMBER_FILTER,
} from "constants/ActionTypes";

const initialState = {
  docNumber: "",
  docRefNumber: "",
  billRefNo: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RETURN_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case RETURN_TRANSACTION_DOC_REF_NUMBER_FILTER:
      return {
        ...state,
        docRefNumberFilter: action.payload,
      };
    case RETURN_TRANSACTION_BILL_REF_NO_FILTER:
      return {
        ...state,
        billRefNoFilter: action.payload,
      };
    default:
      return state;
  }
};
